import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M9.667 16.333A6.667 6.667 0 109.667 3a6.667 6.667 0 000 13.333z" fill="#54585D" /></svg>);